module.exports = __webpack_public_path__ + "img/p4.da7ef4de.png";